import { Box, styled, Typography } from '@mui/material';

const StatusContainer = styled(Box)(({ status }: { status: string }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  backgroundColor:
    status === 'Reverted'
      ? '#ffebeb'
      : status === 'Approved'
      ? '#e6ffed'
      : 'white',
  width: 'fit-content',
  padding: '6px 12px',
  borderRadius: '26px',
}));

const StatusDot = styled(Box)(({ status }: { status: string }) => ({
  height: '8px',
  width: '8px',
  backgroundColor:
    status === 'Reverted'
      ? '#C22F2F'
      : status === 'Approved'
      ? '#2D9E4D'
      : 'white',
  borderRadius: '50%',
}));

const StatusText = styled(Typography)(({ status }: { status: string }) => ({
  fontSize: '16px',
  color:
    status === 'Reverted'
      ? '#C22F2F'
      : status === 'Approved'
      ? '#2D9E4D'
      : 'white',
}));

const ReasonBox = styled(Box)(({ status }: { status: string }) => ({
  color: 'black',
  backgroundColor:
    status === 'Reverted'
      ? '#ffebeb'
      : status === 'Approved'
      ? '#e6ffed'
      : 'white',
  border: `1px solid ${status === 'Reverted' ? 'red' : status === 'Approved' ? 'green' : 'gray'}`,
  padding: '8px',
  borderRadius: '4px',
  marginTop: '8px',
  marginRight: '15px',
}));

const TextAreaStyled = styled('textarea')(({ backgroundColor }: { backgroundColor: string }) => ({
  backgroundColor: backgroundColor || 'white',
  width: '100%',
  padding: '8px',
  borderRadius: '4px',
  border: '1px solid #ccc',
  marginRight: '15px',
  resize: 'vertical',
}));

interface StatusAndReasonSectionProps {
  status: string;
  localstatus: string;
  reason_to_approve?: string;
  reason_to_revert?: string;
  tabState: { 
    showInput: boolean;
    isEditing: boolean;
  };
  tabText: { reasonText: string; tempText: string };
  backgroundColor: string;
  setTabText: React.Dispatch<React.SetStateAction<{ reasonText: string; tempText: string }>>;
  isActionInitiated: boolean;
}

const StatusAndReasonSection: React.FC<StatusAndReasonSectionProps> = ({
  status,
  localstatus,
  reason_to_approve,
  reason_to_revert,
  tabState,
  tabText,
  backgroundColor,
  setTabText,
  isActionInitiated,
}) => {
  const isStatusFinalized = status === 'Approved' || status === 'Reverted';
  const isEditing = tabState?.isEditing;

  const getStatusText = () => {
    if (localstatus === "Approved") {
      return isActionInitiated ? "Please Enter the Reason to Approve:": "Approved";
    } else if (localstatus === "Reverted") {
      return isActionInitiated ? "Please Enter the Reason to Revert" : "Reverted";
    }
    return localstatus;
  };

  return (
    <>
      {!isEditing && isStatusFinalized ? (
        <Box sx={{ flex: 1, padding: '0 15px',marginBottom: '25px' }}>
          <StatusContainer status={status}>
            <StatusDot status={status} />
            <StatusText status={status}>{status}</StatusText>
          </StatusContainer>

          {(reason_to_approve || reason_to_revert) && (
            <ReasonBox status={status}>
              <Typography variant="body1">
                {status === "Approved" ? reason_to_approve : reason_to_revert}
              </Typography>
            </ReasonBox>
          )}
        </Box>
      ) : (
        (tabState?.showInput || isEditing) && (
          <>
            <StatusContainer status={localstatus} sx={{ marginLeft: '15px' }}>
              <StatusDot status={localstatus} />
              <StatusText status={localstatus}>
                {getStatusText()}
              </StatusText>
            </StatusContainer>

            <Box sx={{ flex: 1, padding: '15px' }}>
              <TextAreaStyled
                placeholder="Enter the Reason"
                value={tabText.tempText}
                onChange={(e) =>
                  setTabText((prev) => ({
                    ...prev,
                    tempText: e.target.value,
                  }))
                }
                backgroundColor={'white'}
              />
            </Box>
          </>
        )
      )}
    </>
  );
};

export default StatusAndReasonSection;